import { toast } from "@/hooks/use-toast";
import { ApiError } from "@/lib/queryClient";

/** Standard mutation onError: surface the ApiError detail, else the fallback copy. */
export function toastApiError(e: unknown, fallback: string): void {
  toast({
    description: e instanceof ApiError ? e.message : fallback,
    variant: "destructive",
  });
}
